/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Footer = styled.footer`
  display: flex;
  gap: 16px;
  background: ${Palette.PrimaryGray._000};
  padding: 16px 24px;
  width: 100%;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const Box = styled.div`
  display: flex;
  gap: 16px;
  width: 630px;
  padding: 24px;
`;

export const Content = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
`;

export const NotificationIcon = styled.div`
  background: ${Palette.Primary._500};
  width: 48px;
  height: 48px;
  font-size: 24px;
  color: #fff;
  font-weight: 600;
  line-height: 48px;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
`;

export const ModalDeleteTitle = styled.h3`
  color: ${Palette.PrimaryGray._900};
  text-align: left;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const ModalDeleteText = styled.p`
  text-transform: none;
  padding: 0;
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;
